export default __webpack_public_path__ + "media/images/logo-8d0cfb206fddc6d53f9d77d9142f5cc4.svg";